import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import WarehouseService from "src/_services/WarehouseService";

export const getWarehouses = createAsyncThunk(
    'warehouse/getWarehouses',
    async (params) => {
        const response = await WarehouseService.getWarehouses(params);
        return response.data.body;
    }
);
export const getWarehousesByFilter = createAsyncThunk(
    'warehouse/getWarehousesByFilter',
    async (payload) => {
        const response = await WarehouseService.getWarehousesByFilter(payload);
        return response.data.body;
    }
);
export const createWarehouse = createAsyncThunk(
    'warehouse/createWarehouse',
    async (payload) => {
        const response = await WarehouseService.createWarehouse(payload);
        return response.data.body;
    }
);
export const updateWarehouse = createAsyncThunk(
    'warehouse/updateWarehouse',
    async (payload) => {
        const response = await WarehouseService.updateWarehouse(payload);
        return response.data.body;
    }
);
export const deleteWarehouse = createAsyncThunk(
    'warehouse/deleteWarehouse',
    async (id) => {
        await WarehouseService.deleteWarehouse(id);
        return id;
    }
);

const slice = createSlice({
    name: "warehouse",
    initialState: {
        list: [],
        listLoading: false,
        actionLoading: false,
        errorMessage: null,
        successMessage: null,
        tableOptions: {
            rowCount: 20,
            page: 1,
            pageSize: 20,
        },
        openWarehouse: false
    },
    reducers: {
        updateLoading: (state, action) => {
            state.listLoading = action.payload
        },
        clearWarehouse: (state) => {
            state.list = []
            state.errorMessage = null
            state.successMessage = null
            state.tableOptions = {
                rowCount: 20,
                page: 1,
                pageSize: 20
            }
        },
        updateTableOptions: (state, { payload }) => {
            state.tableOptions = {
                ...state.tableOptions,
                ...payload,
            }
        },
        toggleWarehouseDialog: (state, { payload }) => {
            state.openWarehouse = payload
            state.successMessage = null
            state.errorMessage = null
        }
    },
    extraReducers: {
        //=================get warehouses ================
        [getWarehouses.pending]: (state) => {
            state.listLoading = true
        },
        [getWarehouses.fulfilled]: (state, { payload }) => {
            state.list = [...state.list, ...payload.docs]
            state.tableOptions = {
                ...state.tableOptions,
                rowCount: payload.totalDocs,
                page: payload.page,
            }

            state.listLoading = false
        },
        [getWarehouses.rejected]: (state, payload) => {
            state.listLoading = false
            // console.log('payload error')
            // console.log(payload)
        },
        //=================get warehouses by filter================
        [getWarehousesByFilter.pending]: (state) => {
            state.listLoading = true
        },
        [getWarehousesByFilter.fulfilled]: (state, { payload }) => {
            state.list = [...payload.docs]
            state.listLoading = false
        },
        [getWarehousesByFilter.rejected]: (state, payload) => {
            state.listLoading = false
            console.log('payload error')
            console.log(payload)
        },
        //=================create warehouse================
        [createWarehouse.pending]: (state) => {
            state.errorMessage = null
            state.successMessage = null
            state.actionLoading = true
        },
        [createWarehouse.fulfilled]: (state, { payload }) => {
            if (state.tableOptions.rowCount === state.list.length) {
                state.list = [payload, ...state.list]
            }
            state.tableOptions = {
                ...state.tableOptions,
                rowCount: state.tableOptions.rowCount + 1
            }
            state.actionLoading = false
            state.openWarehouse = false
        },
        [createWarehouse.rejected]: (state) => {
            state.actionLoading = false
        },
        //=================update warehouse================
        [updateWarehouse.pending]: (state) => {
            state.errorMessage = null
            state.successMessage = null
            state.actionLoading = true
        },
        [updateWarehouse.fulfilled]: (state, { payload }) => {
            let warehouses = [...state.list]
            let index = warehouses.findIndex(warehouse => warehouse.id === payload.id)
            if (index !== -1) {
                warehouses[index] = { ...payload }
            }
            state.list = [...warehouses]
            state.actionLoading = false
            state.successMessage = 'Updated successfully'
        },
        [updateWarehouse.rejected]: (state) => {
            state.actionLoading = false
            state.errorMessage = 'Something went wrong please try again'
        },
        //=================delete warehouse================
        [deleteWarehouse.pending]: (state) => {
            state.errorMessage = null
            state.successMessage = null
            state.actionLoading = true
        },
        [deleteWarehouse.fulfilled]: (state, { payload }) => {
            let warehouses = [...state.list]
            let index = warehouses.findIndex(warehouse => warehouse.id === payload)
            if (index !== -1) {
                warehouses.splice(index, 1)
            }
            state.list = [...warehouses]
            state.tableOptions = {
                ...state.tableOptions,
                rowCount: state.tableOptions.rowCount - 1
            }
            state.actionLoading = false
            state.openWarehouse = false
        },
        [deleteWarehouse.rejected]: (state) => {
            state.actionLoading = false
            state.errorMessage = 'Something went wrong please try again'
        },
    },
});


export const {
    updateLoading,
    clearWarehouse,
    updateTableOptions,
    toggleWarehouseDialog
} = slice.actions;



export default slice.reducer;
